<button [attr.id]="'btnDialogClose'" mat-button mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>

<h1 mat-dialog-title>{{ 'intervention-instance.modal_cancel_instance_title' | translate:param }}</h1>

<div mat-dialog-content>
  <app-instance-cancel
    [_intervention]="intervention"
    [_instance]="instance"
    [_collaborators]="collaborators"
    [_members]="members"
  ></app-instance-cancel>
</div>
<div mat-dialog-actions align="end">
  <button [attr.id]="'btnCancel'" mat-button mat-dialog-close="CANCELED">
    {{ 'intervention-instance.modal_cancel' | translate }}
  </button>
  <app-button-feedback
    [_setId]="'btnSetCanceled'"
    (click)="setCanceled()"
    [_defaultButtonText]="'intervention-instance.modal_cancel_instance'"
    [_responseText]="setCanceledResponse | async"
  ></app-button-feedback>
</div>
